import { client } from "../../../Infrastructure/agent";

export const profileService = {
  setLastUrl: (url, userId, menuId) =>
    client.post(`/main/setLastVisitedUrl`, { url, userId, menuId }),
  get: (username) => client.get(`/profiles/${username}`),
  unfollow: (username) => client.del(`/profiles/${username}/follow`),
  getUserProfile: (id) => {
    return client.post("/profile/getuserprofile", { userId: id });
  },
  updateProfile: (data) => client.post("/profile/UpdateBasicProfile", { data }),
  changePassword: (userId, password) =>
    client.post("/profile/ChangePassword", { userId, password }),
};

